(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal2/assets/javascripts/quickplay-modal-header.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal2/assets/javascripts/quickplay-modal-header.js');
"use strict";


const {
  useCallback
} = React;
const {
  ReactIcon: Icon
} = svs.ui;
const {
  getProductBrand
} = svs.components.lbUtils.brandMapping.fn;
const {
  ProductHeader
} = svs.components.lbUi.productHeader;
const QuickplayModalHeader = _ref => {
  let {
    productId,
    handleClose
  } = _ref;
  const _closeOnEnterOrSpace = useCallback(event => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClose();
    }
  }, [handleClose]);
  const closeButton = React.createElement("div", {
    className: "close-header pointer no-text-selection",
    onClick: handleClose,
    onKeyDown: _closeOnEnterOrSpace,
    role: "button",
    tabIndex: 0
  }, React.createElement("div", {
    className: "f-right padding"
  }, React.createElement(Icon, {
    className: "padding-right",
    icon: "close",
    size: 300
  })));
  const branding = getProductBrand(productId);
  return React.createElement("div", {
    className: "quickplay-modal2-header"
  }, React.createElement("div", {
    className: "f-center no-text-selection"
  }, React.createElement(ProductHeader, {
    branding: branding,
    rightButton: closeButton
  })));
};
setGlobal('svs.components.sport.quickplayModal2.QuickplayModalHeader', QuickplayModalHeader);

 })(window);